import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setTrue } from "../../store/slices/IdSlice";
// import PreLoader from "../../assets/ajax-loader.gif";
// import { AnimatedNumber } from "../cardItem/AnimatedNumber";
import { closeAddModelData } from "../../store/slices/modalSlice";
// import { useCart } from "../../hooks/useCart";
import SomeThingWentWrong from "../somethingwentwrong/SomeThingWentWrong";
const baseUrl = import.meta.env.VITE_API_URL;
import "./model.css";

const IMAGE_URL =
  "https://goodhand.b-cdn.net/Assets/Footer_pages/Amer/service-details/im-01.jpg";

interface Price {
  PriceRecordId: number;
  PriceServiceName: string;
  PriceType: string;
  PriceAmount: number;
  PriceCurrency: string;
  Description: string | null;
  serviceName: string;
  serviceid: number;
  OldPriceAmount: number;
}

interface PriceDetails {
  Quantity: number;
  PriceRecordId: number;
  PriceServiceName: string;
  PriceType: string;
  PriceAmount: number;
  PriceCurrency: string;
  Description: string | null;
  serviceName: string;
  serviceid: number;
  OldPriceAmount: number;
}

const Model = () => {
  const dispatch = useDispatch();
  // const { updateCartQuantity } = useCart();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [priceData, setPriceData] = useState<Price[]>([]);
  const [imggg, setImg] = useState<string | undefined>(undefined);
  const [serviceName, setServiceName] = useState<string>();
  const [htmlContent, setHtmlContent] = useState<string | null>("");
  const [quantityData, setQuantityData] = useState<PriceDetails[]>();
  console.log(isLoading,imggg, serviceName, htmlContent, priceData, quantityData)
  const addModalOpen = useSelector(
    (state: { modal: { addModelData: boolean } }) => state.modal.addModelData
  );

  const handleCloseAddModal = () => {
    dispatch(setTrue());
    dispatch(closeAddModelData());
  };

  const [total, setTotal] = useState({
    totalPrice: 0,
    totalQuantity: 0,
    oldPrice: 0,
  });

  function mapPricesWithQuantities(
    servicePrices: Price[],
    quantity: PriceDetails[]
  ) {
    return servicePrices.map((price) => {
      const correspondingQuantity = quantity.find(
        (q) => q.PriceRecordId === price.PriceRecordId
      );
      return {
        ...price,
        Quantity: correspondingQuantity ? correspondingQuantity.Quantity : 0, // Default to 0 if no quantity is found
      };
    });
  }

  const partners = [
    {
      name: "Amer",
      logo: "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/fed.svg",
    },
    {
      name: "Emirates Identity Authority",
      logo: "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/sr2.svg",
    },
    {
      name: "Tas-heel",
      logo: "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/sr6.svg",
    },
    {
      name: "Taw-jeeh",
      logo: "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/tawjeeh-logo-01.svg",
    },
    {
      name: "Dubai Health Authority",
      logo: "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/sr4.svg",
    },
    {
      name: "Dubai Economy & Tourism",
      logo: "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/DED.svg",
    },
    {
      name: "Al Adheed",
      logo: "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/adheeed.svg",
    },
    {
      name: "Legal Translation",
      logo: "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/sr8.svg",
    },
  ];

  const getData = async (serviceid: string) => {
    const uuid = localStorage.getItem("uuid");
    try {
      setIsLoading(true);
      setIsError(false);
      const response = await axios.get(
        `${baseUrl}/api/openRoute/servicesDescrption?ServiceId=${serviceid}&uuid=${uuid}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response) {
        setHtmlContent(
          response.data.servicesDescrption.serviceDetails.insideDescription
        );
        setPriceData(response.data.servicesDescrption.servicePrices);
        setImg(
          response.data.servicesDescrption.serviceDetails?.imageSrc ?? undefined
        );
        setServiceName(
          response.data.servicesDescrption.serviceDetails.serviceName
        );

        const pricesWithQuantities = mapPricesWithQuantities(
          response.data.servicesDescrption.servicePrices,
          response.data.servicesDescrption.quantity
        );

        setQuantityData(pricesWithQuantities);
        calculateTotal(pricesWithQuantities);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setIsError(true);
    }
  };

  useEffect(() => {
    const serviceid = sessionStorage.getItem("serviceid");
    if (serviceid) {
      getData(serviceid);
    }
  }, []);

  // const handleAddToCart = (id: number) => {
  //   quantityData?.forEach((item) => {
  //     if (item.PriceRecordId === id) {
  //       if (item.Quantity === 0) {
  //         item.Quantity = item.Quantity + 1;
  //       }
  //     }
  //   });
  //   calculateTotal(quantityData);

  //   priceData.forEach((item) => {
  //     if (item.PriceRecordId === id) {
  //       updateCartQuantity(item.serviceid, item.PriceRecordId, "plus", 1);
  //     }
  //   });
  // };

  const calculateTotal = (quantityDataa?: PriceDetails[]) => {
    let totalQuantity = 0;
    let totalPrice = 0;
    let oldPrice = 0;

    quantityDataa?.forEach((item) => {
      totalQuantity += item.Quantity; // Add quantity
      totalPrice += item.PriceAmount * item.Quantity; // Add total price for this item
      oldPrice += item.OldPriceAmount * item.Quantity;
    });
    setTotal({ totalPrice, totalQuantity, oldPrice });
  };

  // const handlePlusQuantity = (id: number) => {
  //   quantityData?.forEach((item) => {
  //     if (item.PriceRecordId === id) {
  //       item.Quantity = item.Quantity + 1;
  //     }
  //   });
  //   calculateTotal(quantityData);
  //   priceData.forEach((item) => {
  //     if (item.PriceRecordId === id) {
  //       updateCartQuantity(item.serviceid, item.PriceRecordId, "plus", 1);
  //     }
  //   });
  // };

  // const handleMinusQuantity = (id: number) => {
  //   quantityData?.forEach((item) => {
  //     if (item.PriceRecordId === id) {
  //       if (item.Quantity !== 0) item.Quantity = item.Quantity - 1;
  //     }
  //   });
  //   calculateTotal(quantityData);
  //   priceData.forEach((item) => {
  //     if (item.PriceRecordId === id) {
  //       updateCartQuantity(item.serviceid, item.PriceRecordId, "minus", 1);
  //     }
  //   });
  // };

  if (isError) {
    return <SomeThingWentWrong />;
  }

  return (
    <>
      <Modal
        show={addModalOpen}
        onHide={handleCloseAddModal}
        className=""
        scrollable
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Amer Services</Modal.Title> */}
        </Modal.Header>
        <Modal.Body className="modal-dialog-scrollable">
          <div className="ded-card">
            {/* Banner */}
            <div className="ded-hero">
              <div className="ded-hero-left">
                <div className="ded-eyebrow">User Creation for</div>
                <h2 className="ded-title">New Licensing</h2>
              </div>
              <div className="ded-hero-right">
                <img src={IMAGE_URL} alt="Dubai skyline & metro" />
              </div>
            </div>

            {/* Intro copy */}
            <div className="ded-copy">
              <h3>What is User Creation for New Licensing?</h3>
              <p>
                User Creation is the initial and required step to register a new
                business in the Dubai Department of Economy and Tourism (DET),
                formerly DED. It creates an online user account on the Dubai
                Economy portal, giving access to services like trade name
                reservation, initial approvals, license application, and
                document submission. It verifies identity and links the profile
                to future business activities in the UAE.
              </p>
            </div>

            {/* Required Documents */}
            <section className="ded-req">
              <h4 className="ded-req-title">Required Documents</h4>
              <div className="ded-pills">
                <span className="ded-pill">
                  <svg
                    width="22"
                    height="16"
                    viewBox="0 0 22 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H19C19.5304 1 20.0391 1.21071 20.4142 1.58579C20.7893 1.96086 21 2.46957 21 3V13C21 13.5304 20.7893 14.0391 20.4142 14.4142C20.0391 14.7893 19.5304 15 19 15H3C2.46957 15 1.96086 14.7893 1.58579 14.4142C1.21071 14.0391 1 13.5304 1 13V3Z"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M8 8C8 8.79565 8.31607 9.55871 8.87868 10.1213C9.44129 10.6839 10.2044 11 11 11C11.7956 11 12.5587 10.6839 13.1213 10.1213C13.6839 9.55871 14 8.79565 14 8C14 7.20435 13.6839 6.44129 13.1213 5.87868C12.5587 5.31607 11.7956 5 11 5C10.2044 5 9.44129 5.31607 8.87868 5.87868C8.31607 6.44129 8 7.20435 8 8Z"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M8 8H1"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M14 8H21"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>{" "}
                  Passport
                </span>
                <span className="ded-pill">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 3.25V2.5C1 2.10218 1.15804 1.72064 1.43934 1.43934C1.72064 1.15804 2.10218 1 2.5 1H4"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M1 10.75V11.5C1 11.8978 1.15804 12.2794 1.43934 12.5607C1.72064 12.842 2.10218 13 2.5 13H4"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M10 1H11.5C11.8978 1 12.2794 1.15804 12.5607 1.43934C12.842 1.72064 13 2.10218 13 2.5V3.25"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M10 13H11.5C11.8978 13 12.2794 12.842 12.5607 12.5607C12.842 12.2794 13 11.8978 13 11.5V10.75"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M1.75 7H12.25"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>{" "}
                  Passport Holding Photo
                </span>
              </div>
              <div className="ded-list-card">
                <ol className="ded-list">
                  <li>
                    Valid Passport Copy of the business owner or shareholder
                  </li>
                  <li>Valid Emirates ID Copy (if UAE resident)</li>
                  <li>Mobile Number &amp; Email ID (UAE registered)</li>
                  <li>Visa Page or Entry Stamp (if applicable)</li>
                  <li>Company Name or Trade Name (if already reserved)</li>
                  <li>
                    UAE Local Sponsor’s ID &amp; Contact Details (if applicable)
                  </li>
                  <li>A passport holding a picture of the applicant.</li>
                </ol>
              </div>
              <div className="ded-note">
                <h6>Important note</h6>
                <ol>
                  <li>
                    A UAE-registered mobile number is mandatory for OTP (One
                    Time Password) verification.
                  </li>
                  <li>The passport must be valid for account creation.</li>
                  <li>
                    If the user is not a UAE resident, an entry stamp, a visit
                    visa copy, or UID number is mandatory.
                  </li>
                  <li>
                    Non-UAE residents who have never been to the UAE must apply
                    for a visit visa to obtain a UID number. (To start a
                    Business)
                  </li>
                  <li>
                    Each individual may only create one user profile per
                    passport/Emirates ID.
                  </li>
                  <li>
                    All information must match exactly with immigration and
                    legal records to avoid rejections.
                  </li>
                  <li>
                    Government portals such as UAE Pass may speed up the process
                    for residents.
                  </li>
                  <li>
                    Always ensure the email ID is active and accessible, as
                    further notifications from DET will be sent there.
                  </li>
                  <li>
                    After User Creation, you may proceed to reserve a trade
                    name, get initial approval, and move on to licensing.
                  </li>
                  <li>
                    Incomplete or duplicate user creation attempts may cause
                    delays in license issuance.
                  </li>
                </ol>
              </div>
            </section>

            <section className="ded-partners-section">
              <div className="ded-partners-container">
                <h2 className="ded-partners-title">Partners We Work With</h2>
                <div className="ded-partners-grid">
                  {partners.map((partner, index) => (
                    <div className="ded-partner-card" key={index}>
                      <img
                        src={partner.logo}
                        alt={partner.name}
                        className="ded-partner-logo"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Steps */}
            <section className="ded-steps-wrap">
              <ol className="ded-steps">
                <li className="ded-step">
                  <div className="ded-step-card">
                    <span className="ded-step-pill">STEP 1</span>
                    <h6 className="ded-step-title">Document Collection</h6>
                    <p className="ded-step-text">
                      Gather all personal and identification documents for the
                      individual or company representative.
                    </p>
                  </div>
                </li>
                <li className="ded-step">
                  <div className="ded-step-card">
                    <span className="ded-step-pill">STEP 2</span>
                    <h6 className="ded-step-title">
                      Visit the Dubai Economy Portal
                    </h6>
                    <p className="ded-step-text">
                      Access through the official DET website or the Invest in
                      Dubai platform.
                    </p>
                  </div>
                </li>
                {/* Add STEP 3, 4, 5 similarly */}
              </ol>
            </section>

            {/* About */}
            <section className="ded-about-wrap">
              <h4 className="ded-about-title">About Goodhand</h4>
              <div className="ded-about-card">
                <p>
                  Opening a new business in Dubai begins with the securing of a
                  trade license from the Dubai Economy (DED). We at Goodhand
                  assist you in preparing all documents required for this
                  purpose.
                </p>
                <p>
                  Even though we do not process or deliver trade licenses
                  ourselves, we facilitate your process by providing specialist
                  advisory services and connecting you with trusted business
                  setup advisors when needed.
                </p>
              </div>
            </section>
          </div>
        </Modal.Body>
        {total.totalQuantity > 0 && (
          <Modal.Footer>
            <div
              className={
                total.totalQuantity > 0
                  ? "price-section d-flex w-100 gap-2 align-items-center "
                  : "d-flex justify-content-end"
              }
            >
              <>
                <p className="item-count bg-2 p-2 mb-0 rounded ff-semibold">
                  {total.totalQuantity ? total.totalQuantity : ""}
                </p>
                {/* {data.OldPriceAmount > data.PriceAmount && ( */}
                <p className="current-price flex-grow-1 mb-0 ff-bold">
                  &nbsp;
                  {total.totalPrice
                    ? `<span className="ff-currency ff-medium font-16"></span>${total.totalPrice.toFixed(
                        2
                      )}`
                    : ""}
                  &nbsp;
                  <s className="ff-medium">
                    {total.oldPrice > total.totalPrice
                      ? `<span className="ff-currency ff-medium font-16"></span> ${total.oldPrice.toFixed(
                          2
                        )}`
                      : ""}
                  </s>
                </p>
                {/* )} */}
              </>
              <button
                className={`${total.totalQuantity} > 0 ? "done-button btn btn-primary mt-2 flex-grow-1" : "float-right"`}
                onClick={handleCloseAddModal}
              >
                Done
              </button>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default Model;
